export type Procedure = {
  category: string
  code: string
  description: string
  fee1: string
  fee2: string
  fee3: string
}

export type ProviderSettings = {
  payTo: string
  billingTo: string
  referring: string
  rendering: string
}

export const procedureSettingsData: Procedure[] = [
  {
    category: 'Examination',
    code: '001',
    description: 'Examining Teeth',
    fee1: '1000',
    fee2: '1200',
    fee3: '1500',
  },
  {
    category: 'Cleaning',
    code: '002',
    description: 'Teeth Cleaning',
    fee1: '2000',
    fee2: '2500',
    fee3: '3000',
  },
  {
    category: 'Dentures',
    code: '003',
    description: 'Dentures',
    fee1: '1500',
    fee2: '1700',
    fee3: '2000',
  },
]

export const providerSettingsData: ProviderSettings = {
  payTo: '',
  billingTo: '',
  referring: '',
  rendering: '',
}
